import { SharedModule } from '../../shared/shared.module';
import { UserDetailsModule } from './user-details/user-details.module';
import { UserListModule } from './user-list/user-list.module';
import { UserNewComponent } from './user-new/user-new.component';
import { UsersComponent } from './users.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UserEditionModule } from './user-edition/user-edition.module';
import { AdminEditionModule } from './admin-edition/admin-edition.module';
import { TypeaheadModule } from 'ngx-bootstrap';

@NgModule({
  imports: [
    NgbModule,
    SharedModule,
    UserListModule,
    UserDetailsModule,
    AdminEditionModule,
    UserEditionModule,
    TypeaheadModule
  ],
  declarations: [UsersComponent, UserNewComponent],
  exports: [UsersComponent],
  entryComponents: [UserNewComponent]
})
export class UsersModule { }
